export const GIFT_COLORS = {
  None: 0xFFFFFF,
  Green: 0x24FF18,
  Teal: 0x03FFA7,
  Purple: 0xC923E9,
  Red: 0xFF1646,
  Light_Blue: 0x02BBFF,
  Dark_Blue: 0x025DFF,
  Orange: 0xFF8502,
  Pink: 0xFF2FE9,
  Yellow: 0xfed500,
  Fish_Pink: 0xFB3DD7,
  Fish_Blue: 0x337DFF,
  Fish_Green: 0x00BEA8,
  Tales_Purple: 0x814CFF,
  Tales_Blue: 0x0C23FC,
  Tales_Light_Blue: 0x48A6FF,
  Tales_Pink: 0xfb3f99,
  Tales_Green: 0x0CFC33,
};

export class GiftGraphic extends Phaser.Group {
  /**
   * A class to display a gift with configurable box and ribbon tint.
   @param {number} x
   @param {number} y
   * @param {{
    * giftType: 1 | 2,
    * boxTint:number,
    * ribbonTint:number,
    * highlight:boolean
    * isButton:boolean
    * callback:any
    * callbackContext:any,
    * useFullGift:boolean
   * }} config The config for the gift graphic.
   * @param {Phaser.Group} groupToAdd The group to add this graphic to.
   */

  constructor(x, y, config, groupToAdd) {
    super(G.game, groupToAdd);
    this.config = config;
    this.btnSprite = null;
    this.x = x;
    this.y = y;
    this.anchor = { x: 0.5, y: 0.5 };

    const modifier = this.config.giftType === 1 ? '' : '2';
    const boxAssetStr = this.config.useFullGift ? 'gift_full' : `gift_box${modifier}`;

    if (this.config.isButton) {
      this.boxImg = new G.Button(0, 0, boxAssetStr, this.config.callback, this.config.callbackContext);
      this.btnSprite = this.boxImg;
      this.addChild(this.boxImg);
    } else {
      this.boxImg = new G.Image(0, 0, boxAssetStr, 0.5, this);
    }
    if (this.config.giftType === 1 && !this.config.useFullGift && G.OMTsettings.elements.gifts.useGiftTrim) {
      this.extraDetailImg = new G.Image(0, 0, 'gift_trim', 0.5, this);
      this.extraDetailImg.tint = 0xFFA56E;
    }

    this.ribbonImg = new G.Image(0, 0, `gift_ribbon${modifier}`, 0.5, this);
    this.highlightImg = new G.Image(0, 0, `gift_highlight${modifier}`, 0.5, this);
    this.highlightImg.visible = this.config.highlight;
    if (this.config.useFullGift) {
      this.ribbonImg.visible = false;
      // this.boxImg.visible = false;
      this.highlightImg.visible = false;
    }

    if (!config.useFullGift) {
      this.boxImg.tint = this.config.boxTint || 0xFFFFFF;
      this.ribbonImg.tint = this.config.ribbonTint || 0xFF0000;
    }

  }

  setTintForAll(tint) {
    this.boxImg.tint = tint;
    this.ribbonImg.tint = tint;
  }
}
